var map = {
	"./eggs_BLUE RASPBERRY.png": 856,
	"./eggs_BLUEBERRY.png": 3392,
	"./eggs_COTTON CANDY.png": 3656,
	"./eggs_DRAGON FRUIT.png": 2817,
	"./eggs_FRUIT PUNCH.png": 3846,
	"./eggs_GRAPE.png": 573,
	"./eggs_GREEN APPLE.png": 8717,
	"./eggs_KeyLimePie.png": 3750,
	"./eggs_LEMON.png": 1789,
	"./eggs_LYCHEE.png": 3760,
	"./eggs_MANGO.png": 6170,
	"./eggs_ORANGE CREAMSICLE.png": 6158,
	"./eggs_PEACH.png": 5519,
	"./eggs_STRAWBERRY.png": 5069,
	"./eggs_WATERMELON.png": 2220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7535;